import http from "../http-common";

class OrganigramaAreaDataService {
  getAll() {
    return http.get("/organigramaareas");
  }

  getOrganigramaArea(dataobject, sortfield, sorttype) {
    return http.get(`/organigramaareas/search/?parentid=${dataobject.parentid}&childid=${dataobject.childid}&childcategory=${dataobject.childcategory}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/organigramaareas/${id}`);
  }

  getList(organigramaid, competenciaid, userid) {
    return http.get(`/organigramaareas/listofjudges/?organigramaid=${organigramaid}&competenciaid=${competenciaid}&userid=${userid}`);
  }

  getCompetenciasAreasUsuarios(userid) {
    return http.get(`/organigramaareas/competenciasareasusuarios/?userid=${userid}`);
  }  

  getListCompetenciasUsuario(userid) {
    return http.get(`/organigramaareas/listofcompetenciasusuario/?userid=${userid}`);
  }  

  create(data) {
    return http.post("/organigramaareas/neworganigramaarea", data);
  }

  update(id, data) {
    return http.put(`/organigramaareas/${id}`, data);
  }

  deletenode(id) {
    return http.delete(`/organigramaareas/deletenode/${id}`)
  }

  delete(id) {
    return http.delete(`/organigramaareas/${id}`);
  }

  deleteAll() {
    return http.delete(`/organigramaareas`);
  }

  findById(id) {
    return http.get(`/organigramaareas?id=${id}`);
  }
}

export default new OrganigramaAreaDataService();